import staticModel from '@/components/Feature/NewPolicy/_content.json';

export default {
  SET_EDIT_MODE_ACTIVATED(state, payload) {
    state.editMode = payload;
  },
  TOGGLE_EDIT_MODE(state) {
    state.editMode = !state.editMode;
  },
  TOGGLE_ACTIVE_MODE(state) {
    state.defaultToActiveField = !state.defaultToActiveField;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  UPDATE_PRICE(state, payload) {
    state.price = payload;
  },
  TOGGLE_MODEL_TYPE(state) {
    state.useStaticModel = !state.useStaticModel;

    if (state.useStaticModel) {
      return (state.vueModel = staticModel);
    }

    return (state.vueModel = state.responseData);
  },
  UPDATE_VUE_MODEL(state, payload) {
    if (state.useStaticModel) {
      return;
    }

    state.vueModel = payload;
    state.responseData = payload;
  },
  SET_INITIAL_VUE_MODEL(state) {
    state.initialVueModel = state.vueModel;
  },
  RESTORE_INITIAL_VUE_MODEL(state) {
    state.vueModel = state.initialVueModel;
  },
  SET_MODAL_DATA(state, payload) {
    state.modalData = payload;
  },
  SET_MODAL_VISIBILITY(state, payload) {
    state.showModal = payload;
  },
  SET_BASKET_POSITION(state, payload) {
    state.basketFixed = payload;
  },
  SET_VIEW_MODE(state, payload) {
    state.viewMode = payload;
  },
  SET_HULL_WARNING(state, payload) {
    state.hullWarning = payload;
  }
};
